import React from "react";
import { CheckMarkPurple,PlusIcon } from "../../../AssetComponents/Images";

import {
  Bathub, HairDryer, Shower, HotWater, SoapDrop, Heating, ToiletSeat, BathHanger
} from "../../Amenities/Bathroom";


import {
  SwimmingPool, ValleyView, Park, Balcony
} from "../../Amenities/View";

// Import all amenity icons - Bedroom and Laundry
import {
  Bed, BedDouble, BedroomHanger, DresserDrawer, DressingMirror, SafeBox, SofaDouble, TrowelBrush, WashingMachine
} from "../../Amenities/Bedroom";

// Import all amenity icons - Entertainment
import { GamePad } from "../../Amenities/Entertainment";

// Import all amenity icons - Home safety
import {
  Alarm, CCTV, FireExtinguisher, MedicalCase, TvStand
} from "../../Amenities/HomeSafety";

// Import all amenity icons - Internet and office
import {
  LaptopTable, Wifi, WorkJob
} from "../../Amenities/InternetAndOffice";

// Import all amenity icons - Kitchen and dining
import {
  Blender, CoffeeMachine, Dishes, DishWasher, ForkKnife, Fridge, Induction, Kitchen, PlateFork, SaltPepper, Stove, TableChair, Trash, WineGlass
} from "../../Amenities/Kitchen";

// Import all amenity icons - Outdoor
import {
  BeachUmbrella, ChildrenSlide, Lounge, Sun, Swing
} from "../../Amenities/Outdoor";

// Import all amenity icons - Parking
import { Parking } from "../../Amenities/Parking";

// Import all amenity icons - Services
import {
  Breakfast, CampFire, Cat, CleaningSprayAction, Dog, HouseKey, Longterm, ManStaff, Smoking, Stairs, Userprofile
} from "../../Amenities/Services.";

// Import all amenity icons - Family
import {
  BabyBedroom, BookFairyTale, ToyCubes
} from "../../Amenities/Family";

// Import all amenity icons - Heating and cooling
import { Appliance, Fan } from "../../Amenities/HeatingandCooling";

// Import all amenity icons - Others
import {
  AirConditioning, Beach, BeachView, BedLinenTowels, CableTv, CarbonMonoxideDetector, CityView, CleaningProducts, CoffeeMaker,
  ComplimentarySoapShampooConditioner, CookingBasics, CookwareKitchenUtensils, CrockeryCutlery, DiningTable, DryingRack, Elevator, Essentials,
  FamilyKidsFriendly, FirstAidKit, FreeParkingWithGarage, Gym, Hangers, IronIroningBoard, Kettle, Marina, MarinaView, Microwave, NoParties,
  Oven, PlayGround, Reception, Refrigerator, RoomDarkeningShades, Seaview, SmartTv, SmokeDetectors, SmokingNotAllowed, StreamingServiceSuchAsNetflix,
  Toaster, Toilet, TrashCans, Wardrobe, WineGlasses, WirelessInternet
} from "../../Amenities/Others";

// Define all amenity groups with their icons - adding category for "All" view
const amenityGroups = {
  "Bathroom": [
    { id: 'bathub', Icon: Bathub, label: 'Bathtub', category: 'Bathroom' },
    { id: 'hairdryer', Icon: HairDryer, label: 'Hair Dryer', category: 'Bathroom' },
    { id: 'shower', Icon: Shower, label: 'Shower', category: 'Bathroom' },
    { id: 'hotwater', Icon: HotWater, label: 'Hot Water', category: 'Bathroom' },
    { id: 'soapdrop', Icon: SoapDrop, label: 'Soap', category: 'Bathroom' },
    { id: 'heating', Icon: Heating, label: 'Heating', category: 'Bathroom' },
    { id: 'toiletseat', Icon: ToiletSeat, label: 'Toilet', category: 'Bathroom' },
    { id: 'bathhanger', Icon: BathHanger, label: 'Bath Hanger', category: 'Bathroom' }
  ],
  
  "Location features": [
    { id: 'swimmingpool', Icon: SwimmingPool, label: 'Swimming Pool', category: 'Location features' },
    { id: 'valleyview', Icon: ValleyView, label: 'Valley View', category: 'Location features' },
    { id: 'park', Icon: Park, label: 'Park', category: 'Location features' },
    { id: 'balcony', Icon: Balcony, label: 'Balcony', category: 'Location features' }
  ],
  
  "Bedroom and Laundry": [
    { id: 'trowelbrush', Icon: TrowelBrush, label: 'Towels', category: 'Bedroom and Laundry' },
    { id: 'hanger', Icon: BedroomHanger, label: 'Hanger', category: 'Bedroom and Laundry' },
    { id: 'beddouble', Icon: BedDouble, label: 'Bed Double', category: 'Bedroom and Laundry' },
    { id: 'bed', Icon: Bed, label: 'Bed', category: 'Bedroom and Laundry' },
    { id: 'dresserdrawer', Icon: DresserDrawer, label: 'Dresser Drawer', category: 'Bedroom and Laundry' },
    { id: 'dressingmirror', Icon: DressingMirror, label: 'Dressing Mirror', category: 'Bedroom and Laundry' },
    { id: 'safebox', Icon: SafeBox, label: 'Safe Box', category: 'Bedroom and Laundry' },
    { id: 'sofadouble', Icon: SofaDouble, label: 'Sofa', category: 'Bedroom and Laundry' },
    { id: 'washingmachine', Icon: WashingMachine, label: 'Washing Machine', category: 'Bedroom and Laundry' }
  ],
  
  "Entertainment": [
    { id: 'gamepad', Icon: GamePad, label: 'Game Console' }
  ],
  
  "Home safety": [
    { id: 'medicalcase', Icon: MedicalCase, label: 'First Aid Kit' },
    { id: 'fireextinguisher', Icon: FireExtinguisher, label: 'Fire Extinguisher' },
    { id: 'tvstand', Icon: TvStand, label: 'TV' },
    { id: 'alarm', Icon: Alarm, label: 'Alarm' },
    { id: 'cctv', Icon: CCTV, label: 'CCTV' }
  ],
  
  "Internet and office": [
    { id: 'wifi', Icon: Wifi, label: 'WiFi' },
    { id: 'workjob', Icon: WorkJob, label: 'Workspace' },
    { id: 'laptoptable', Icon: LaptopTable, label: 'Laptop Friendly' }
  ],
  
  "Kitchen and dining": [
    { id: 'kitchen', Icon: Kitchen, label: 'Kitchen' },
    { id: 'forkknife', Icon: ForkKnife, label: 'Cutlery' },
    { id: 'stove', Icon: Stove, label: 'Stove' },
    { id: 'induction', Icon: Induction, label: 'Induction' },
    { id: 'dishes', Icon: Dishes, label: 'Dishes' },
    { id: 'fridge', Icon: Fridge, label: 'Refrigerator' },
    { id: 'tablechair', Icon: TableChair, label: 'Dining Table' },
    { id: 'coffeemachine', Icon: CoffeeMachine, label: 'Coffee Machine' },
    { id: 'blender', Icon: Blender, label: 'Blender' },
    { id: 'saltpepper', Icon: SaltPepper, label: 'Condiments' },
    { id: 'dishwasher', Icon: DishWasher, label: 'Dishwasher' },
    { id: 'wineglass', Icon: WineGlass, label: 'Wine Glasses' },
    { id: 'trash', Icon: Trash, label: 'Trash Bin' },
    { id: 'platefork', Icon: PlateFork, label: 'Dining Set' }
  ],
  
  "Outdoor": [
    { id: 'childrenslide', Icon: ChildrenSlide, label: 'Kids Playground' },
    { id: 'lounge', Icon: Lounge, label: 'Lounge Area' },
    { id: 'swing', Icon: Swing, label: 'Swing' },
    { id: 'sun', Icon: Sun, label: 'Sun Deck' },
    { id: 'beachumbrella', Icon: BeachUmbrella, label: 'Beach Umbrella' }
  ],
  
  "Parking and facilities": [
    { id: 'parking', Icon: Parking, label: 'Parking' }
  ],
  
  "Services": [
    { id: 'cat', Icon: Cat, label: 'Cat Friendly' },
    { id: 'dog', Icon: Dog, label: 'Dog Friendly' },
    { id: 'breakfast', Icon: Breakfast, label: 'Breakfast' },
    { id: 'longterm', Icon: Longterm, label: 'Long Term Stays' },
    { id: 'housekey', Icon: HouseKey, label: 'Self Check-in' },
    { id: 'userprofile', Icon: Userprofile, label: 'Host Available' },
    { id: 'cleaningspray', Icon: CleaningSprayAction, label: 'Cleaning Service' },
    { id: 'smoking', Icon: Smoking, label: 'Smoking Allowed' },
    { id: 'campfire', Icon: CampFire, label: 'Fireplace' },
    { id: 'stairs', Icon: Stairs, label: 'Stairs' },
    { id: 'manstaff', Icon: ManStaff, label: 'Staff Available' }
  ],
  
  "Family": [
    { id: 'toyscubes', Icon: ToyCubes, label: 'Toys' },
    { id: 'fairytale', Icon: BookFairyTale, label: 'Children Books' },
    { id: 'babybedroom', Icon: BabyBedroom, label: 'Baby Equipment' }
  ],
  
  "Heating and cooling": [
    { id: 'appliance', Icon: Appliance, label: 'Appliances' },
    { id: 'fan', Icon: Fan, label: 'Fan' }
  ],
  
  "Others": [
    { id: 'CookwareKitchenUtensils', Icon: CookwareKitchenUtensils, label: 'Cookware' },
    { id: 'DryingRack', Icon: DryingRack, label: 'Drying Rack' },
    { id: 'CableTv', Icon: CableTv, label: 'Cable TV' },
    { id: 'Toaster', Icon: Toaster, label: 'Toaster' },
    { id: 'Wardrobe', Icon: Wardrobe, label: 'Wardrobe' },
    { id: 'DiningTable', Icon: DiningTable, label: 'Dining Table' },
    { id: 'Reception', Icon: Reception, label: 'Reception' },
    { id: 'CityView', Icon: CityView, label: 'City View' },
    { id: 'SmokeDetectors', Icon: SmokeDetectors, label: 'Smoke Detector' },
    { id: 'MarinaView', Icon: MarinaView, label: 'Marina View' },
    { id: 'Gym', Icon: Gym, label: 'Gym' },
    { id: 'CarbonMonoxideDetector', Icon: CarbonMonoxideDetector, label: 'CO Detector' },
    { id: 'Hangers', Icon: Hangers, label: 'Hangers' },
    { id: 'TrashCans', Icon: TrashCans, label: 'Trash Cans' },
    { id: 'WineGlasses', Icon: WineGlasses, label: 'Wine Glasses' },
    { id: 'StreamingServiceSuchAsNetflix', Icon: StreamingServiceSuchAsNetflix, label: 'Streaming Service' },
    { id: 'CrockeryCutlery', Icon: CrockeryCutlery, label: 'Crockery' },
    { id: 'Toilet', Icon: Toilet, label: 'Toilet' },
    { id: 'Oven', Icon: Oven, label: 'Oven' },
    { id: 'CoffeeMaker', Icon: CoffeeMaker, label: 'Coffee Maker' },
    { id: 'ComplimentarySoapShampooConditioner', Icon: ComplimentarySoapShampooConditioner, label: 'Toiletries' },
    { id: 'BeachView', Icon: BeachView, label: 'Beach View' },
    { id: 'Elevator', Icon: Elevator, label: 'Elevator' },
    { id: 'WirelessInternet', Icon: WirelessInternet, label: 'WiFi' },
    { id: 'FreeParkingWithGarage', Icon: FreeParkingWithGarage, label: 'Free Parking' },
    { id: 'SmartTv', Icon: SmartTv, label: 'Smart TV' },
    { id: 'Marina', Icon: Marina, label: 'Marina' },
    { id: 'RoomDarkeningShades', Icon: RoomDarkeningShades, label: 'Blackout Curtains' },
    { id: 'IronIroningBoard', Icon: IronIroningBoard, label: 'Iron' },
    { id: 'BedLinenTowels', Icon: BedLinenTowels, label: 'Linens' },
    { id: 'Kettle', Icon: Kettle, label: 'Kettle' },
    { id: 'Microwave', Icon: Microwave, label: 'Microwave' },
    { id: 'AirConditioning', Icon: AirConditioning, label: 'AC' },
    { id: 'Seaview', Icon: Seaview, label: 'Sea View' },
    { id: 'Beach', Icon: Beach, label: 'Beach Access' },
    { id: 'PlayGround', Icon: PlayGround, label: 'Playground' },
    { id: 'Refrigerator', Icon: Refrigerator, label: 'Refrigerator' },
    { id: 'FamilyKidsFriendly', Icon: FamilyKidsFriendly, label: 'Family Friendly' },
    { id: 'NoParties', Icon: NoParties, label: 'No Parties' },
    { id: 'Essentials', Icon: Essentials, label: 'Essentials' },
    { id: 'CleaningProducts', Icon: CleaningProducts, label: 'Cleaning Products' },
    { id: 'FirstAidKit', Icon: FirstAidKit, label: 'First Aid Kit' },
    { id: 'CookingBasics', Icon: CookingBasics, label: 'Cooking Basics' },
    { id: 'SmokingNotAllowed', Icon: SmokingNotAllowed, label: 'No Smoking' }
  ]
};

// Component to render a single amenity item - UI exactly as in screenshots
// Enhanced AmenityItem component with proper naming and animations
export const AmenityItem = ({ amenity, selected, onToggle }) => {
  const { id, Icon } = amenity;
  
  return (
    <div className="w-full items-center justify-between flex p-1.5 sm:p-2 hover:bg-gray-50 rounded-md">
      <div className="flex items-center gap-1.5 sm:gap-2">
        <Icon />
        {/* Only show the label once */}
        {/* <span className="text-sm">{label}</span> */}
      </div>
      {selected ? (
        // Show purple checkmark when selected
        <div 
          onClick={() => onToggle(id)}
          className="cursor-pointer"
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="text-[#5b1dee] transition-transform duration-300 transform rotate-0 sm:w-6 sm:h-6"
          >
            <path 
              d="M9 12L11 14L15 10" 
              stroke="#5b1dee" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <circle 
              cx="12" 
              cy="12" 
              r="9" 
              stroke="#5b1dee" 
              strokeWidth="1.5"
            />
          </svg>
        </div>
      ) : (
        // Show plus icon when not selected
        <div 
          onClick={() => onToggle(id)}
          className="cursor-pointer"
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="sm:w-6 sm:h-6"
          >
            <path 
              d="M12 6V18" 
              stroke="#959595" 
              strokeWidth="1.5" 
              strokeLinecap="round"
            />
            <path 
              d="M18 12L6 12" 
              stroke="#959595" 
              strokeWidth="1.5" 
              strokeLinecap="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

// Component to render a group of amenities for a category - UI matched to screenshots
// Updated AmenityGroup component
export const AmenityGroup = ({ category, selectedAmenities, onToggleAmenity }) => {
  // Define amenities based on selected category
  let amenities = [];
  
  if (category === "All") {
    // For "All" category, gather amenities from all categories
    Object.keys(amenityGroups).forEach(cat => {
      if (cat !== "All") {
        // Add category information to each amenity for proper toggle handling
        const amenitiesWithCategory = amenityGroups[cat].map(item => ({
          ...item,
          category: cat // Ensure category is stored with the amenity
        }));
        amenities = [...amenities, ...amenitiesWithCategory];
      }
    });
  } else {
    amenities = amenityGroups[category] || [];
  }
  
  if (amenities.length === 0) {
    return <div className="text-gray-500 p-2 text-sm">No amenities in this category</div>;
  }
  
  return (
    <div className="grid grid-cols-2 gap-1 sm:gap-2">
      {amenities.map(amenity => {
        // Determine which category to use for checking selection status
        const effectiveCategory = category === "All" ? amenity.category || category : category;
        
        return (
          <AmenityItem
            key={amenity.id}
            amenity={amenity}
            selected={(selectedAmenities[effectiveCategory] || []).includes(amenity.id)}
            onToggle={(id) => onToggleAmenity(effectiveCategory, id)}
          />
        );
      })}
    </div>
  );
};

// Get all available amenity categories
export const getAmenityCategories = () => {
  return Object.keys(amenityGroups);
};

// Get total count of selected amenities
export const getSelectedAmenityCount = (selectedAmenities) => {
  return Object.values(selectedAmenities || {}).reduce(
    (total, amenities) => total + (amenities?.length || 0), 
    0
  );
};